// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2tCj3","dragIcon":"SortableItem_dragIcon__2LUV6","disabled":"SortableItem_disabled__1MpyV"};